<template>
    <div class="back-btn">
        <div class="goBack" @click="goBack"></div>
    </div>
</template>

<script>
    export default {
        methods:
        {
            goBack(){
                history.go(-1);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .back-btn{
        position: fixed;
        right: 20px;
        bottom: 30px;
        .goBack:before {
            content: " ";
            display: inline-block;
            height: 10px;
            width: 10px;
            border-width: 2px 2px 0 0;
            border-color: #fff;
            border-style: solid;
            -webkit-transform: matrix(-0.71, 0.71,0.71, 0.71, 0, 0);
            transform: matrix(-0.71, 0.71, 0.71, 0.71, 0, 0);
            position: absolute;
            top: calc(50% - 6px);
            left: calc(50% - 4px);
        }
        &>.goBack{
            cursor: pointer;
            width: 40px;
            height: 40px;
            background: #cccccc;
            -moz-border-radius: 60px;
            -webkit-border-radius: 60px;
            border-radius: 60px;
        }
    }
</style>
